import React, { useEffect, useState } from 'react';
import { DISCOUNT_UNITS } from '../constants/constants';
import { useSelector } from 'react-redux';
import { cartCurrencySelector, cartTotal } from '../redux/selectors/cartSelector';
import { customRound } from '../lib/customRound';
import { formatNumberWithSeparator } from '../lib/formatNumberWithSeparator';

function useTotalDiscount(productId) {
    const [productDiscount, setProductDiscount] = useState('-');
    const currency = useSelector((state) => cartCurrencySelector(state));
    const total = useSelector((state) => cartTotal(state, { product_id: productId || null }));
    const sign = <span dangerouslySetInnerHTML={{ __html: currency?.sign }}></span>;

    useEffect(() => {
        if (total?.discount > 0 && total?.total > 0) {
            setProductDiscount(
                <>
                    {sign}
                    {formatNumberWithSeparator((total?.subtotal - total?.total), ',', 2)}&nbsp;(
                    {customRound(total?.discount)}
                    {DISCOUNT_UNITS[total?.discount_unit.toUpperCase()]}
                    &nbsp;Off)
                </>
            );
        } else {
            setProductDiscount('-');
        }
    }, [total?.total]);

    return productDiscount;
}

export default useTotalDiscount;
